export const FETCH_ZOMATO_ACCESS_TOKEN = 'FETCH_ZOMATO_ACCESS_TOKEN'